import { createFileRoute, redirect } from "@tanstack/react-router";

// Staff Management moved to /admin/staff. Keep this path working for existing
// bookmarks/links by redirecting.
export const Route = createFileRoute("/_authenticated/admin/settings")({
  beforeLoad: () => {
    throw redirect({ to: "/admin/staff" });
  },
});
